module.exports = __webpack_public_path__ + "static/media/banner-career.121b443c.svg";